import React, { Fragment } from "react";

class Explore_Reservation extends React.Component {
  render() {
    return <></>;
  }
}

export default Explore_Reservation;
